import { baseUrl } from "./baseURL";
import { fetchAccessToken } from "./tokensAuth";

const fetchSmartReportData = async (labNumber, lastName) => {
  try {
    const SRA1 = labNumber;
    const SRA2 = lastName;
    const token = await fetchAccessToken(SRA1, SRA2);
    //console.log(labNumber, lastName);
    const headers = {
      "Content-Type": "application/json",
      "X-Frame-Options": "DENY",
      Authorization: `Bearer ${token}`,
    };
    const url = `${baseUrl()}/GetSmartReportData/`;
    const requestBody = {
      LabNumber: labNumber,
      LastName: lastName,
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(requestBody),
      });
      //  console.log(response);
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching Smart Report data:", error);
      throw error;
    }
  } catch (error) {
    console.error("Error fetching Smart Report data:", error);
    throw error;
  }
};

const fetchLastNameVerification = async (labNumber, lastName) => {
  try {
    const SRA1 = labNumber;
    const SRA2 = lastName;
    const token = await fetchAccessToken(SRA1, SRA2);
    //console.log(labNumber, lastName);
    const headers = {
      "Content-Type": "application/json",
      "X-Frame-Options": "DENY",
      Authorization: `Bearer ${token}`,
    };
    const url = `${baseUrl()}/GetSmartReportData/`;
    const requestBody = {
      LabNumber: labNumber,
      LastName: lastName,
    };
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(requestBody),
      });
      // console.log(response);
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching Smart Report data:", error);
      throw error;
    }
  } catch (error) {
    console.error("Error fetching Smart Report data:", error);
    throw error;
  }
};

const sendScreenshotWithLabNumberForPDF = async (
  apiLabNumber,
  lastName,
  screenshots,
) => {
  console.log(apiLabNumber, lastName, screenshots);
  // try {
  //   const SRA1 = apiLabNumber;
  //   const SRA2 = lastName;
  //   const token = await fetchAccessToken(SRA1, SRA2);
  //   console.log(SRA1, SRA2);
    const headers = {
      "Content-Type": "application/json",
      "X-Frame-Options": "DENY",
     // Authorization: `Bearer ${token}`,
    };
   // console.log(apiLabNumber, lastName, screenshots);
    const url = `${baseUrl()}GeneratePdf`;
    const requestData = {
      LabNumber: apiLabNumber,
      LastName: lastName,
      ImageBase64: screenshots, // Sending base64 encoded image
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(requestData),
      });
      // console.log(response);
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching Smart Report data:", error);
      throw error;
    }
  // } catch (error) {
  //   console.error("Error fetching Smart Report data:", error);
  //   throw error;
  // }
};

// const sendScreenshotWithLabNumberForPDF = async (apiLabNumber, lastName, screenshots) => {
//    console.log(apiLabNumber, lastName, screenshots);
//    const url = `${baseUrl()}GeneratePdf`;
//    const requestData = {
//         LabNumber: apiLabNumber,
//         LastName : lastName,
//         ImageBase64: screenshots, // Sending base64 encoded image
//     };
//     const headers = {
//       'Content-Type': 'application/json'
//     };
//     try {        
//         const response = await fetch(url, {
//             method: 'POST',
//             headers: headers,
//             body: JSON.stringify(requestData),
//         });
//         console.log(response);
//         if (!response.ok) {
//             throw new Error('Failed to fetch data');
//         }
//         const data = await response.json();
//         return data;
//     } catch (error) {
//         console.error('Error fetching Smart Report data:', error);
//         throw error; 
//     }
// };

export default fetchSmartReportData;
export { sendScreenshotWithLabNumberForPDF, fetchLastNameVerification };
